import * as PIXI from 'pixi.js';
import * as THREE from 'three';
import { pixiRenderer } from '@/scenes'
import PianoUtil from '@/util/piano-util';
import { EngineAbstract } from '@/components/engine-abstract';
import Camera from '@/components/three/camera';
import { WIDTH, HEIGHT } from '@/constants';
import Piano3D from '@/components/three/piano-3d'
import { EVENT_BUS } from '@/model/event-bus';
import { buildHighway, buildGem } from '@/components/three/highway';
export const UNITS_PER_SECOND = 95;
const RESOLUTION_SCALING = 0.5;
const keyColorWhite = new THREE.Color(0xb0cbc9);
const keyColorBlack = new THREE.Color(0xf48f32);
const keyColorCorrect = new THREE.Color(0x00FF00);
const keyColorWrong = new THREE.Color(0xFF0000);

export class Engine3D extends EngineAbstract {
    constructor({
        chartHeight = HEIGHT,
        chartWidth,
        pianoKeyWidth,
        judgementLinePositionPx = 0,
        pxPerSecond = 300,
        notes = [],
        totalLengthBeats,
        duration,
        bpm,
        boundaries
    } = {}) {
        super();
        this.boundaries = boundaries;
        this.pianoKeyWidth = pianoKeyWidth;
        this.PADDING = -(chartWidth) / 2;
        this.noteGems = [];
        this.barLines = [];
        this.scrollable = new PIXI.Container();
        this.judgementLinePositionPx = judgementLinePositionPx;
        this.pxPerSecond = pxPerSecond;
        this.chartHeight = chartHeight;
        this.chartWidth = chartWidth;
        this.duration = duration;
        this.bpm = bpm;
        // layer 1 - video bg
        this.createBackground();
        // layer 2 - three.js
        this.initThreejsScene();
        this.addChild(this.scrollable);
        this.initPiano();
        this.initJudgementLine();
        this.renderHighway(this.duration, this.bpm);
        this.renderBarlines(totalLengthBeats);
        this.renderNotes(notes.filter(n => n.pitch));
        this._threeJsUpdate = (dt) => this.updateThreeJs(dt);
        PIXI.Ticker.shared.add(this._threeJsUpdate);
    }

    cleanup() {
        PIXI.Ticker.shared.remove(this._threeJsUpdate);
        // return pixi canvas
    }

    initThreejsScene() {
        this.scene = new THREE.Scene();
        this.camera = Camera;
        const renderer = new THREE.WebGLRenderer(
            {
                antialias: true,
                alpha: true
            }
        );
        renderer.setSize(WIDTH, HEIGHT);
        renderer.setPixelRatio(RESOLUTION_SCALING)
        this.renderer = renderer;
        document.querySelector('#three').appendChild(renderer.domElement);
        const texture_UI = new THREE.Texture( pixiRenderer );
        texture_UI.needsUpdate = true;
        const material_UI = new THREE.MeshBasicMaterial( {map: texture_UI, side:THREE.DoubleSide } );
        material_UI.transparent = true;
        const mesh_UI = new THREE.Mesh( new THREE.PlaneGeometry(WIDTH, HEIGHT), material_UI );
        mesh_UI.position.set(0,0,0);
        this.scene.add( mesh_UI );
    }

    renderHighway(duration, bpm) {
        this.highway = buildHighway({ duration, bpm }, this.boundaries);
        this.scene.add(this.highway);
    }

    initPiano() {
        const piano = Piano3D.build(this.boundaries);
        this.scene.add(piano);

        EVENT_BUS.on('MIDI_noteOn', ({ pianoNote }) => {
            (piano.highlights[pianoNote] || {}).visible = true;
            const key = piano.keys[pianoNote];
            key.children[0].material.color = keyColorCorrect;
            // animateMeshPosition(piano,
            //     { dx: 0, dy: 0, dz: -6 },
            //     { x: -407, y: -90, z: -35 },
            //     100);
        });
        EVENT_BUS.on('MIDI_noteOff', ({ pianoNote }) => {
            (piano.highlights[pianoNote] || {}).visible = false;
            const key = piano.keys[pianoNote];
            key.children[0].material.color = PianoUtil.isBlackKey(pianoNote) ? keyColorBlack : keyColorWhite;
        });
        EVENT_BUS.on('NOTE_HIT', () => {
        })
    }

    initJudgementLine() {
        let geometry = new THREE.BoxGeometry(WIDTH / 2, 8, 8);
        let material = new THREE.MeshBasicMaterial(
            { color: keyColorCorrect, wireframe: true }
        );
        let mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(0, 4, -40);
        this.scene.add(mesh);
    }

    createBackground() {
        function initVideoSprite() {
            let texture = PIXI.Texture.from('public/binignore/menubg3.mp4');
            let videoSprite = new PIXI.Sprite(texture);
            videoSprite.width = WIDTH;
            videoSprite.height = HEIGHT;
            videoSprite.anchor.set(0.5, 0.5);

            videoSprite.texture.baseTexture.resource.source.loop = true;
            videoSprite.texture.baseTexture.resource.source.autoPlay = true;
            return videoSprite;
        }
        this.videoBg = initVideoSprite();
        this.addChild(this.videoBg);
    }

    renderNotes(notes) {
        notes.forEach((note) => {
            const keyNumber = note.pianoNote;
            const isBlackKey = PianoUtil.isBlackKey(keyNumber);
            const whites = PianoUtil.whiteKeysBetween(this.boundaries.min, keyNumber);
            const gem = buildGem(note, this.boundaries);
            this.highway.add(gem);
            this.noteGems.push({
                gem,
                xmlNote: note
            });
        })
    }

    renderBarlines(totalLengthBeats) {
        for (let i = 0; i < totalLengthBeats; i++) {

        }
    }

    updateThreeJs(dt) {
        this.renderer.render(this.scene, Camera);

        // complete hack :(
        (this.noteGems || []).filter(({ gem }) => gem.flame.visible).forEach(
            ({ gem }) => gem.flame.animator.update(dt * 10)
        )
    }

    update(currentTime) {
        this.highway.position.y = 0 - currentTime * UNITS_PER_SECOND;
    }
}